class ProjectsAPI {

  static all(state, sub_id) {
    let url = this.postsUrl(state, sub_id)

    return fetch(url, {
      credentials: 'same-origin'
    })
    .then(this.handleStatus)
  }

  static handleStatus(response) {
    if (!response.ok) {
      // Fetch doesn't reject on HTTP error status
      throw Error(`Request rejected with status ${response.status}`)
    }
    return response
  }

  static postsUrl(params, sub_id) {

    const {currentBranch, count, offset} = params

    let branches = currentBranch ? `&branches=${currentBranch}` : ''
    sub_id = (sub_id != 0) ? `&subs=${sub_id}` : ''

    return `/wp-json/wp/v2/projects?per_page=${count}&offset=${offset}${branches}${sub_id}`
  }

}

export default ProjectsAPI



// WEBPACK FOOTER //
// ./src/js/projects/api/ProjectsAPI.js